export const getHighlightColor = ({ hasValue, isDynamic })=>{
    if (!hasValue) {
        return "";
    }
    if (isDynamic) {
        return "purple-500";
    }
    return "brand-primary";
};
